import React from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import BookingBg from "../assets/media/booking_form_bg.jpeg";
import TickImg from "../assets/media/check_img.png";

const BookingConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get booking details passed from BookingForm
  const bookingDetails = location.state?.bookingDetails || {};

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoToProfile = () => {
    navigate("/profile");
  };

  return (
    <div
      className="custom-booking-confirmation-section"
      style={{
        // backgroundImage: `url(${BookingBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "50px 20px",
      }}
    >
      <div className="container-fluid" style={{ maxWidth: "800px" }}>
        <div className="custom-booking-confirmation-wrapper">
          <div
            className="custom-booking-confirmation-card py-5 px-4 rounded text-center"
            style={{
              background: "rgba(255, 255, 255, 1)",
              border: "1px solid rgba(255, 255, 255, 1)",
              boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            }}
          >
            {/* Success Checkmark */}
            <div className="custom-confirmation-icon mb-4">
              <div
                className="custom-check-circle d-inline-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "75px",
                  height: "75px",
                }}
              >
                <img src={TickImg} className="w-100 h-100" alt="" />
              </div>
            </div>

            {/* Confirmation Message */}
            <div className="custom-confirmation-content mb-4">
              <h2
                className="mb-3"
                style={{
                  color: "#259dd1",
                  fontWeight: "bold",
                  // textShadow: "0 1px 1px white",
                }}
              >
                Booking Confirmed!
              </h2>
              <p
                className="mb-2"
                style={{ color: "#000000", fontSize: "16px" }}
              >
                Your adventure has been confirmed successfully. We've sent a
                confirmation email to <strong>{bookingDetails.email || "your email"}</strong>.
              </p>

              {/* Display booking summary if available */}
              {bookingDetails.booking_for && (
                <div
                  className="custom-confirmation-details py-2 px-3 rounded mb-3"
                  style={{
                    // background: "rgba(255, 255, 255, 0.25)",
                    // backdropFilter: "blur(5px)",
                    // WebkitBackdropFilter: "blur(5px)",
                    // border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  <p className="mb-2" style={{ color: "black" }}>
                    <strong>Booking Summary</strong>
                  </p>
                  <div className="text-start" style={{ color: "black" }}>
                    <p className="mb-1">
                      <strong>Trip:</strong> {bookingDetails.booking_for}
                    </p>
                    <p className="mb-1">
                      <strong>Name:</strong> {bookingDetails.firstName}{" "}
                      {bookingDetails.lastName}
                    </p>
                    <p className="mb-1">
                      <strong>Travelers:</strong>{" "}
                      {bookingDetails.numberOfTravelers} person
                      {bookingDetails.numberOfTravelers > 1 ? "s" : ""}
                    </p>
                    {bookingDetails.totalAmount && (
                      <p className="mb-0">
                        <strong>Total Amount:</strong> ₹
                        {bookingDetails.totalAmount}
                      </p>
                    )}
                  </div>
                </div>
              )}

              <div
                className="custom-confirmation-details px-3 py-2 rounded"
              >
                <p className="mb-2" style={{ color: "black" }}>
                  <strong>What's Next?</strong>
                </p>
                <p className="mb-0" style={{ color: "black" }}>
                  Our team will contact you shortly to confirm your travel
                  arrangements and provide further details about your trip.
                </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="custom-confirmation-actions mt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <button
                    onClick={handleGoHome}
                    className="custom-btn-home btn w-100 py-2"
                    style={{
                      background: "rgb(255, 255, 255)",
                      backdropFilter: "blur(5px)",
                      WebkitBackdropFilter: "blur(5px)",
                      border: "2px solid #259dd1",
                      color: "#259dd1",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = "#259dd1";
                      e.target.style.color = "white";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = "rgba(255, 255, 255)";
                      e.target.style.color = "#259dd1";
                    }}
                  >
                    <i className="fas fa-home me-2"></i>
                    Go Back to Home
                  </button>
                </div>
                <div className="col-md-6">
                  <button
                    onClick={handleGoToProfile}
                    className="custom-btn-profile btn w-100 py-2"
                    style={{
                      backgroundColor: "#259dd1",
                      border: "2px solid #259dd1",
                      color: "#ffffff",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#1e7ea3";
                      e.target.style.borderColor = "#1e7ea3";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#259dd1";
                      e.target.style.borderColor = "#259dd1";
                    }}
                  >
                    <i className="fas fa-user me-2"></i>
                    View Profile
                  </button>
                </div>
              </div>
            </div>

            {/* Additional Info */}
            <div
              className="custom-confirmation-footer mt-4 pt-3"
              style={{ borderTop: "1px solid rgba(255, 255, 255, 0.3)" }}
            >
              <p className="mb-0" style={{ color: "black" }}>
                <small>
                  <i className="fas fa-info-circle me-1"></i>
                  Need help? Contact our support team at Operations@sortedtrips.in
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;
